import { useState, useEffect } from 'react';

export const useIsWindowWiderThan = (width: number): boolean => {
  const [isWindowWider, setIsWindowWider] = useState(false);

  useEffect(() => {
    setIsWindowWider(width <= window.innerWidth);
  }, [width]);

  useEffect(() => {
    const onWindowResize = () => {
      const newWiderState = width <= window.innerWidth;
      if (isWindowWider !== newWiderState) {
        setIsWindowWider(newWiderState);
      }
    };

    window.addEventListener('resize', onWindowResize);

    return () => {
      window.removeEventListener('resize', onWindowResize);
    };
  }, [isWindowWider, width]);

  return isWindowWider;
};
